let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export function convertDateTime(datetime) {
  var messageTime = new Date(datetime)
  var hours = messageTime.getHours()
  var minutes = messageTime.getMinutes()
  if(minutes < 10) {
    minutes = "0" + minutes
  }
  var amPm = "AM"
  if(hours > 12) {
    amPm = "PM"
    hours -= 12
  }
  if (hours === 12) {
    amPm = "PM"
  }
  if(hours === 0) {
    hours = 12
  }

  var date = messageTime.getDate()
  var current = new Date()
  var dateDif = Math.round(current - messageTime)/(1000*60*60*24)
  if(current.getMonth() === messageTime.getMonth() && current.getDay() === messageTime.getDay()) {
    return hours + ":" + minutes + " " + amPm
  } else if (dateDif <= 6) { // is in last 6 days
    return days[messageTime.getDay()] + " " + hours + ":" + minutes + " " + amPm
  } else {
    return months[messageTime.getMonth()] + " " + date + " " + hours + ":" + minutes + " " + amPm
  }
}